import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class CampagnesService {

  constructor(private globalService: GlobalService) {}

  add(data: any): Observable<any> {
    return this.globalService.post('/SP-AddCampaign/', data);
  }

  getById(id: string): Observable<any> {
    return this.globalService.get(`/SP-GetCampaignById/?id=${id}`);
  }

  getAll(): Observable<any> {
    return this.globalService.get('/SP-GetAllCampaigns/');
  }

  getArchives(): Observable<any> {
    return this.globalService.get('/SP-GetArchivesCampaign/');
  }

  getArchivesNotFinalised(): Observable<any> {
    return this.globalService.get('/SP-GetArchiveNotFinaliseCampaign/');
  }

  getMallImporters(): Observable<any> {
    return this.globalService.get('/SP-GetMallImporterCampaign/');
  }

  update(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateCampaign/', data);
  }

  updateIsOn(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateIsOnCampaign/', data);
  }

  updateConsiderArchive(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateConsiderArchiveCampaign/', data);
  }

  getStatsSms(data: any): Observable<any> {
    return this.globalService.post('/SP-GetSmsApi/', data);
  }

  archive(data: any): Observable<any> {
    return this.globalService.post('/SP-ArchiveCampaign/', data);
  }

  delete(data: any): Observable<any> {
    return this.globalService.post('/SP-DeleteCampaign/', data);
  }

  updateAjoutTerminer(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateAjoutTerminerCampaign/', data);
  }

  updatePriorite(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdatePrioriteCampaign/', data);
  }

  relancerFailed(data: any): Observable<any> {
    return this.globalService.post('/SP-RelancerFailedCampaign/', data);
  }

  relancerDelivered(): Observable<any> {
    return this.globalService.get('/SP-ReloadNotReallySend/');
  }

  relancerTousDelivered(): Observable<any> {
    return this.globalService.post('/SP-ReloadNotReallySend/', { idMachine: 'all' });
  }

  exportFile(data: any): Observable<any> {
    return this.globalService.post('/SP-ExportFileCampaign/', data);
  }

  downloadExportFile(data: any): Observable<any> {
    return this.globalService.post('/SP-ExportExcelFile/', data);
  }

  updateIsOnGeneric(endpoint: string, data: any): Observable<any> {
    return this.globalService.post(endpoint, data);
  }

  deleteSmppMessage(idUser: string, type: number): Observable<any> {
    return this.globalService.post('/SP-DeleteSmppMessage/', { idUser, type });
  }

  switchCampaignSmpp(data: any): Observable<any> {
    return this.globalService.post('/SP-SwitchCampaignSmpp/', data);
  }
}
